/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React from "react";
import cancelWhite from "./Cancel.svg";
import ready from "./Ready.svg";
import upload from "./Upload.svg";
import pencil from "./Pencil.svg";
import check from "./Check.svg";
import user from "./User.svg";
import key from "./Key.svg";
import up from "./Up.svg";
import down from "./Down.svg";
import right from "./Right.svg";
import openNew from "./OpenNew.svg";
import addUser from "./AddUser.svg";
import trash from "./Trash.svg";
import settings from "./Settings.svg";
import help from "./Help.svg";
import cal from "./Calendar.svg";
import android from "./Android.svg";
import ios from "./Ios.svg";
import upgrade from "./Upgrade.svg";
import search from "./Search.svg";
import protect from "./Protect.svg";

const icons: { [key: string]: any } = {
  cancel: cancelWhite,
  pencil,
  upload,
  check,
  user,
  key,
  up,
  down,
  right,
  help,
  cal,
  open_new: openNew,
  add_user: addUser,
  trash,
  settings,
  android,
  ios,
  upgrade,
  search,
  protect,
};

export const Ico = (props: any) => {
  const icon = icons[props.name] || ready;
  return (
    <img
      src={icon}
      alt={props.name}
      style={{ verticalAlign: "top", ...props.style }}
      className={props.className}
    />
  );
};
